import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmDialogComponent } from '../../../common/confirm-dialog/confirm-dialog.component';
import { DialogMessageTypes, MessageDialogComponent } from '../../../common/message-dialog/message-dialog.component';
import { ProcessingDialogComponent } from '../../../common/processing-dialog/processing-dialog.component';
import { DxTextBoxComponent } from 'devextreme-angular';
import { Router } from '@angular/router';
import { AppService } from '../../../../app-service';
import { AppComponent } from '../../../../app.component';
import { ResponseObject } from '../../../../models/response-object';
import { ResponseStatus } from '../../../enums/response-statuses';
import { ParentsPortalControllerService } from '../../../../services/parents-portal/parents-portal-controller-service';

@Component({
  selector: 'app-parents-login',
  templateUrl: './parents-login.component.html',
  styleUrls: ['./parents-login.component.scss']
})
export class ParentsLoginComponent implements OnInit {

  passwordMode: String = "password";
  passwordButton: any;
  loginDetails: LoginDetails= new LoginDetails();
  @ViewChild(MessageDialogComponent) messageDialog: MessageDialogComponent;
  @ViewChild(ProcessingDialogComponent) processingDialog: ProcessingDialogComponent;
  @ViewChild(ConfirmDialogComponent, { static: true }) confirmDialog: ConfirmDialogComponent;
  @ViewChild(DxTextBoxComponent, { static: true }) txtPassword: DxTextBoxComponent;
  
  constructor(private router: Router,
    private parentPortalControllerService: ParentsPortalControllerService,
    private appService: AppService,
    private myapp: AppComponent) { 
    this.passwordButton = {
      icon: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7klEQVRYw+2YP0tcQRTFz65xFVJZpBBS2O2qVSrRUkwqYfUDpBbWQu3ELt/HLRQ/Q8RCGxVJrRDEwj9sTATxZ/Hugo4zL/NmV1xhD9xi59177pl9986fVwLUSyi/tYC+oL6gbuNDYtyUpLqkaUmfJY3a+G9JZ5J2JW1J2ivMDBSxeWCfeBxYTHSOWMcRYLOAEBebxtEVQWPASQdi2jgxro4E1YDTQIJjYM18hszGbew4EHNq/kmCvgDnHtI7YBko58SWgSXg1hN/btyFBM0AlwExczG1YDZrMS4uLUeUoDmgFfjLGwXEtG05wNXyTc4NXgzMCOAIGHD8q0ATuDZrempkwGJ9+AfUQ4K+A/eEseqZ/UbgdUw4fqs5vPeW+5mgBvBAPkLd8cPju+341P7D/WAaJGCdOFQI14kr6o/zvBKZYz11L5Okv5KGA89Kzu9K0b0s5ZXt5PjuOL6TRV5ZalFP4F+rrnhZ1Cs5vN6ijmn7Q162/ThZq9+YNW3MbfvDAOed5cxdGL+RFaUPKQtjI8DVAr66/u9i6+jJzTXm+HFEVqxVYBD4SNZNKzk109HxoycPaG0bIeugVDTp4hH2qdXJDu6xOAAWiuQoQdLHhvY1aEZSVdInG7+Q9EvSz9RrUKqgV0PP3Vz7gvqCOsUj+CxC9LB1Dc8AAAASdEVYdEVYSUY6T3JpZW50YXRpb24AMYRY7O8AAAAASUVORK5CYII=",
      type: "default",
      onClick: () => {
        this.passwordMode = this.passwordMode === "text" ? "password" : "text";
      }
    };
  }

  ngOnInit(): void {
    sessionStorage.clear();
    sessionStorage.setItem("token","");
  }

  logIn(){
    this.loginDetails.Password = this.txtPassword.value;
    if (this.loginDetails.Username == "" || this.loginDetails.Username == undefined || this.loginDetails.Password == "" || this.loginDetails.Password == undefined) {
      this.messageDialog.show("Provide your username and password.", DialogMessageTypes.Information);
    }
    else {
      this.processingDialog.show();
      this.parentPortalControllerService.utilitiesPost("ParentsPortalUsers/AuthenticateParent", this.loginDetails).subscribe(
        data => {
          this.processingDialog.hide();
          let response: ResponseObject = data;
          if (response.Status == ResponseStatus.Success) {
            sessionStorage.setItem("GUID", "6291D72A-1B6E-4525-8057-92FEE3954A4A");
            sessionStorage.setItem("token",response.Token.toString());
            sessionStorage.setItem("LoggedIn","true");
            sessionStorage.setItem("OPE",response.Reference.toString());
            this.myapp.getMenu();
            this.appService.setUserLoggedIn(true);
            this.router.navigate(['/', 'parents-portal-home']);
          }
          else if (response.Status == ResponseStatus.Failure) {
            this.messageDialog.show(response.StatusDescription, DialogMessageTypes.Information);
          }
          else {
            this.messageDialog.show("A system error was encountered processing your request, try again later.", DialogMessageTypes.SystemError);
          }
        },
        error => {
          this.processingDialog.hide();
          this.messageDialog.show("A system error was encountered processing your request, try again later.", DialogMessageTypes.SystemError);
        }
      )     
    }
  }
}

export class LoginDetails {
  public Username: String;
  public Password: String;
  public NewPassword:String;
  public OldPassword:String;
}
